import { ChangeDetectionStrategy, Component, ViewChild, inject } from '@angular/core';
import { CanComponentDeactivate } from '@app/core/auth/can-component-deactivate.interface';
import { LogicTransferFormComponent } from '../components/logic-transfer-form/logic-transfer-form.component';
import {
  LogicTransferFormConfig,
  LOGIC_TRANSFER_HEADER_ACTIONS,
  LOGIC_TRANSFER_TABLE_SECTIONS,
  LOGIC_TRANSFER_FORM_FIELDS,
} from '../logic-transfer.config';

@Component({
  selector: 'app-logic-transfer-add',
  standalone: true,
  imports: [LogicTransferFormComponent],
  templateUrl: './logic-transfer-add.component.html',
  styleUrls: ['./logic-transfer-add.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogicTransferAddComponent implements CanComponentDeactivate {
  @ViewChild('formWrapper') private readonly formWrapper?: LogicTransferFormComponent;

  config: LogicTransferFormConfig = {
    title: 'logic_transfer.form.add.title', 
    formFields: [...LOGIC_TRANSFER_FORM_FIELDS],
    headerActions: LOGIC_TRANSFER_HEADER_ACTIONS,
    tableSections: LOGIC_TRANSFER_TABLE_SECTIONS,
    listRoute: '/stock/transfer-order',
  };

  canDeactivate(): boolean {
    return this.formWrapper?.canDeactivate() ?? true;
  }
}
